import { createReducer, on } from '@ngrx/store';
import { saveKeyValue } from './common-actions';

export const commonReducer = createReducer(
  {},
  on(saveKeyValue, (state, { key, value }) => ({ ...state, [key]: value }))
);
